const SET_USER_PROFILE = "SET_USER_PROFILE";
const SET_CURRENT_USER_PROFILE = "SET_CURRENT_USER_PROFILE";
const SET_USER_APPS = "SET_USER_APPS";
const SET_CURRENT_USER_APPS = "SET_CURRENT_USER_APPS";
const SET_USER_ADMIN_APPS = "SET_USER_ADMIN_APPS";
const SET_DERMARISE_PIN = "SET_DERMARISE_PIN";
export const setCurrentUserProfile = (payload) => {
    return {
        type: SET_CURRENT_USER_PROFILE,
        payload,
    };
};
export const setUserProfile = (payload) => {
    return {
        type: SET_USER_PROFILE,
        payload,
    };
};
export const setUserApps = (payload) => {
    return {
        type: SET_USER_APPS,
        payload,
    };
};
export const setUserAdminApps = (payload) => {
    return {
        type: SET_USER_ADMIN_APPS,
        payload,
    };
};

export const setDermariseUserPins = (payload) => {
    return {
        type: SET_DERMARISE_PIN,
        payload,
    };
};
export const setAuthenticateUserApps = (payload) => {
    return {
        type: SET_CURRENT_USER_APPS,
        payload,
    };
};

const initialState = {
    currentProfile: undefined,
    appUserProfile: undefined,
    userApps: undefined,
    authenticateUserApps: undefined,
    userAdminApps: undefined,
    dermarisePins: undefined,
};

export default (state = initialState, action) => {
    switch (action.type) {
        case SET_USER_PROFILE:
            if (!action.payload) {
                return {
                    ...initialState,
                };
            }
            return {
                ...state,
                appUserProfile: {
                    // ...state.appUserProfile,
                    ...action.payload,
                },
            };
        case SET_CURRENT_USER_PROFILE:
            if (!action.payload) {
                return {
                    ...initialState,
                };
            }
            return {
                ...state,
                currentProfile: {
                    ...state.currentProfile,
                    ...action.payload,
                },
            };

        case SET_USER_APPS:
            if (!action.payload) {
                return {
                    ...initialState,
                };
            }
            return {
                ...state,
                userApps: {
                    ...state.userApps,
                    ...action.payload,
                },
            };
        case SET_CURRENT_USER_APPS:
            if (!action.payload) {
                return {
                    ...initialState,
                };
            }
            return {
                ...state,
                authenticateUserApps: {
                    ...state.authenticateUserApps,
                    ...action.payload,
                },
            };
        case SET_USER_ADMIN_APPS:
            if (!action.payload) {
                return {
                    ...initialState,
                };
            }
            return {
                ...state,
                userAdminApps: {
                    ...state.userAdminApps,
                    ...action.payload,
                },
            };
        case SET_DERMARISE_PIN:
            if (!action.payload) {
                return {
                    ...initialState,
                };
            }
            return {
                ...state,
                dermarisePins: {
                    //  ...state.userAdminApps,
                    ...action.payload,
                },
            };
        //  return state.set("currentProfile", action.payload);
        default:
            return state;
    }
};
